import { create } from 'zustand';
import { registerSW } from 'virtual:pwa-register';

/**
 * 서비스워커는 앱 시작 시 바로 등록한다 (잠금 화면도 오프라인에서 열려야 하므로).
 * 새 버전이 있으면 상태만 바꾸고, 적용은 사용자가 UpdatePrompt에서 직접 한다 (자동 새로고침 금지).
 */
type SwState = { update: ((reload?: boolean) => Promise<void>) | null };
export const useSw = create<SwState>(() => ({ update: null }));

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator) || import.meta.env.DEV) return;
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      useSw.setState({ update: updateSW });
    },
  });
}
